import { Box } from "@chakra-ui/react";
import * as React from "react";

function DownstreamLeasedAssetsPreview() {
  return (
    <Box>
    </Box>
  );
}

export default DownstreamLeasedAssetsPreview;